import * as HeroIconsSolid from "@heroicons/react/24/solid";
import * as HeroIconsOutline from "@heroicons/react/24/outline";

interface Props {
  name: keyof typeof HeroIconsSolid | keyof typeof HeroIconsOutline;
  className?: string;
  onClick?: () => void;
  variant?: "solid" | "outline";
  title?: string;
  testId?: string;
}

function GetHeroIcon({
  name,
  className,
  onClick,
  variant = "solid",
  title,
  testId,
}: Props) {
  const SelectedIcon =
    variant === "solid" ? HeroIconsSolid[name] : HeroIconsOutline[name];
  if (!SelectedIcon) return;
  return (
    <span
      data-testid={testId}
      className={`dark:text-white transition-transform duration-300 ease-in-out transform ${
        name === "MinusIcon" ? "rotate-180" : "rotate-0"
      }`}
    >
      <SelectedIcon className={className} onClick={onClick} title={title} />
    </span>
  );
}

export default GetHeroIcon;
